import { render, staticRenderFns } from "./AddLocationModal.vue?vue&type=template&id=3859a485"
import script from "./AddLocationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddLocationModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports